// actionCreators.js
import { createAction } from 'redux-actions';
import * as actionTypes from './actionTypes';

export const clearErrorAndIsLoading = createAction(actionTypes.CLEAR_ERROR_AND_ISLOADING);

export const clearAllErrorAndIsLoading = createAction(actionTypes.CLEAR_ALL_ERROR_AND_ISLOADING);

export const fetchAvailableYearsRequest = createAction(actionTypes.FETCH_AVAILABLE_YEARS_REQUEST);

export const fetchAvailableYearsSuccess = createAction(actionTypes.FETCH_AVAILABLE_YEARS_SUCCESS);

export const fetchAvailableYearsFailure = createAction(actionTypes.FETCH_AVAILABLE_YEARS_FAILURE);

export const fetchInfoRequest = createAction(actionTypes.FETCH_INFO_REQUEST, (year) => ({ year }));

export const fetchInfoSuccess = createAction(actionTypes.FETCH_INFO_SUCCESS, (year, info) => ({
  year,
  info,
}));

export const fetchInfoFailure = createAction(actionTypes.FETCH_INFO_FAILURE, (year, error) => ({
  year,
  error,
}));
